import Vue from 'vue';
import Router from 'vue-router';
import DashboardLayout from '@/layout/DashboardLayout';
import AuthLayout from '@/layout/AuthLayout';
import OnlineStoreLayout from '@/layout/OnlineStoreLayout';
import ServerResponseLayout from '@/layout/ServerResponseLayout';
import LandingPageLayout from '@/layout/LandingPage/LandingPageLayout';
import secureStorage from './controllers/secureStorage.js'
import { async } from 'q';
Vue.use(Router)

const router = new Router({
    linkExactActiveClass: 'active',
    mode: 'history',
    routes: [
      {
        path:'/releases',
        name:'releases',
        component: () => 
          import('./views/Releases.vue')
      },
      {
            path: '/dashboard',
            redirect: 'dashboard',
            component: DashboardLayout,
            children: [{
                    path: '/dashboard',
                    name: 'dashboard',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Dashboard.vue')
                },
                {
                    path: '/landing_page',
                    name: 'landing_page',
                    component: () =>
                        import ('./views/LandingPage.vue')
                },
                {
                    path: '/sales_dashboard',
                    name: 'sales_dashboard',
                    component: () =>
                        import ('./views/SalesDashboard.vue')
                },
                {
                    path: '/integration_dashboard',
                    name: 'integration_dashboard',
                    component: () =>
                        import ('./views/IntegrationDashboard.vue')
                },
                {
                    path: '/sales_dashboard_with_filter',
                    name: 'sales_dashboard_with_filter',
                    component: () =>
                        import ('./views/SalesDashboardWithFilter.vue')
                },
                {
                    path: '/products',
                    name: 'products',
                    component: () =>
                        import ('./views/Products/Products.vue')
                },
                {
                    path: '/products_v2',
                    name: 'product explorer',
                    component: () =>
                        import ('./views/Products/ProductsV2.vue'),
                    props: (route) => ({
                        ...route.params
                    })
                },
                {
                    path: '/add_on_charges',
                    name: 'add_on_charges',
                    component: () =>
                        import ('./views/Documents/AddOnCharge.vue')
                },
                {
                    path: '/children_products/:id',
                    name: 'children_products',
                    component: () =>
                        import ('./views/Products/ProductChildDetail.vue')
                },
                {
                    path: '/product_profiles',
                    name: 'product_profiles',
                    component: () =>
                        import ('./views/Product Profiles V2/ProductProfile.vue')
                },
                {
                    path: '/pos_profiles',
                    name: 'pos_profiles',
                    component: () =>
                        import ('./views/POS Profiles/PosProfile.vue')
                },
                {
                    path: '/customer_profiles',
                    name: 'customer_profiles',
                    component: () =>
                        import ('./views/Customer Profiles/CustomerProfile.vue')
                },
                {
                    path: '/system_profiles',
                    name: 'system_profiles',
                    component: () =>
                        import ('./views/System Profiles/SystemProfile.vue')
                },
                {
                    path: '/backend_profiles',
                    name: 'backend_profiles',
                    component: () =>
                        import ('./views/Backend Profiles/BackendProfile.vue')
                },
                {
                    path: '/advanced_profiles',
                    name: 'advanced_profiles',
                    component: () =>
                        import ('./views/Advanced Profiles/AdvancedProfile.vue')
                },
                {
                    path: '/pos_documents',
                    name: 'pos_documents',
                    component: () =>
                        import ('./views/POS Documents/PosDocument.vue')
                },
                {
                    path: '/pos_readings',
                    name: 'pos_readings',
                    component: () =>
                        import ('./views/POS Documents/PosReading.vue')
                },
                {
                    path: '/bir_reports',
                    name: 'bir_reports',
                    component: () =>
                        import ('./views/Bir Reports/BirReport.vue')
                },
                {
                    path: '/basic_sales_reports',
                    name: 'basic_sales_reports',
                    component: () =>
                        import ('./views/Basic Sales Reports/BasicSalesReport.vue')
                },
                {
                  path: '/oms_reports',
                  name: 'oms_reports',
                  component: () => import('./views/Oms Reports/OmsReport.vue'),
                },
                {
                    path: '/basic_inventory_reports',
                    name: 'basic_inventory_reports',
                    component: () =>
                        import ('./views/Basic Sales Reports/BasicInventoriesReport.vue')
                },
                {
                    path: '/basic_operations_reports/:code',
                    name: 'basic_operations_reports',
                    component: () =>
                        import ('./views/Basic Operations Reports/BasicOperationsReport.vue')
                },
                {
                    path: '/sales_invoice_reports/',
                    name: 'sales_invoice_reports',
                    component: () =>
                        import ('./views/Sales Invoice/SalesInvoice.vue')
                },
                {
                    path: '/profile_listing_reports/',
                    name: 'profile_listing_reports',
                    component: () =>
                        import ('./views/Profile Listing/ProfileListing.vue')
                },
                {
                    path: '/audit_reports/',
                    name: 'audit_reports',
                    component: () =>
                        import ('./views/Audit Reports/AuditReport.vue')
                },
                {
                    path: '/pos_document_form',
                    name: 'pos_document_form',
                    component: () =>
                        import ('./views/POS Documents/PosDocumentDetail.vue'),
                    props: (route) => ({
                        ...route.params
                    })
                },
                {
                    path: '/pos_session_details',
                    name: 'pos_session_details',
                    component: () =>
                        import ('./views/Tools/PosSessionDetails.vue'),
                    props: (route) => ({
                        ...route.params
                    })
                },
                {
                    path: '/documents',
                    name: 'documents',
                    component: () =>
                        import ('./views/Documents/Document.vue')
                },
                {
                    path: '/document_form',
                    name: 'document_form',
                    component: () =>
                        import ('./views/Documents/DocumentForm.vue')
                },
                {
                    path: '/product_updates',
                    name: 'product_updates',
                    component: () =>
                        import ('./views/Products/ProductMassUpdate.vue'),
                    props: (route) => ({
                        ...route.params
                    })
                },
                // {
                //   path: '/core_plugins',
                //   name: 'core plugins',
                //   component: () => import('./views/Plugins/Core/PluginIndex.vue')
                // },
                {
                    path: '/tools',
                    name: 'tools',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Tools.vue')
                },
                {
                    path: '/expiry_date/:param',
                    name: 'expiry_date',
                    component: () =>
                          import ('./views/ExpiryDate.vue')
                },
                {
                    path: '/jobs',
                    name: 'jobs',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Jobs.vue')
                },
                // Removing MMS Admin Tools on client side
                // {
                //   path: '/acc_system_modules',
                //   name: 'acc_system_modules',
                //   component: () => import('./views/Admin/AccountSystemModule.vue')
                // },
                {
                    path: '/my_plugins',
                    name: 'my_plugins',
                    component: () =>
                        import ('./views/Admin/AccountPlugins.vue')
                },
                {
                    path: '/promotions_dashboard_v2',
                    name: 'promotions_dashboard_v2',
                    component: () =>
                        import ('./views/Promotions/PromotionsDashboardV2.vue')
                },
                {
                    path: '/promotions_dashboard',
                    name: 'promotions_dashboard',
                    component: () =>
                        import ('./views/Promotions/PromotionsDashboard.vue')
                },
                {
                    path: '/gift_certificates_dashboard',
                    name: 'gift_certificates_dashboard',
                    component: () =>
                        import ('./views/Gift Certificates/GiftCertificatesDashboard.vue')
                },
                {
                    path: '/advanced_promotions/:id',
                    name: 'advanced_promotions',
                    component: () =>
                        import ('./views/Promotions/AdvancedPromotions.vue')
                },
                {
                    path: '/advanced_promotions_v2/:id',
                    name: 'advanced_promotions_v2',
                    component: () =>
                        import ('./views/Promotions/AdvancedPromotionsV2.vue')
                },
                {
                    path: '/online_stores',
                    name: 'online_stores',
                    component: () =>
                        import ('./views/Sales Channel/OnlineStores.vue')
                },
                {
                    path: '/sales_channel_promotions',
                    name: 'sales_channel_promotions',
                    component: () =>
                        import ('./views/Sales Channel/SalesChannelPromotions.vue')
                },
                {
                    path: '/sales_channel_promotions/:id',
                    name: 'sales_channel_promotion',
                    component: () =>
                        import ('./views/Sales Channel/SalesChannelPromotions.vue')
                },

                // Admin Paths ================================================
                {
                    path: '/admin_users',
                    name: 'admin_users',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Admin/AdminUsers.vue')
                },
                {
                    path: '/admin_logs',
                    name: 'admin_logs',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Admin/AdminLogs.vue')
                },
                {
                    path: '/internal_admin',
                    name: 'internal_admin',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/SystemModule.vue')
                },
                {
                    path: '/pos_updater',
                    name: 'pos_updater',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Admin/PosUpdater.vue')
                },
                {
                    path: '/pos_updater_v2',
                    name: 'pos_updater_v2',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Admin/PosUpdaterV2.vue')
                },
                {
                    path: '/release_manager',
                    name: 'release_manager',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Admin/ReleaseManager.vue')
                },
                {
                    path: '/developer_accounts',
                    name: 'developer_accounts',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Developer/Developer.vue')
                },
                {
                    path: '/admin_plugins',
                    name: 'admin_plugins',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Ripple Admin/AdminPlugin.vue')
                },

                // Sample Layouts ================================================
                {
                    path: '/icons',
                    name: 'icons',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Icons.vue')
                },
                {
                    path: '/profile',
                    name: 'profile',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/UserProfile.vue')
                },
                {
                    path: '/maps',
                    name: 'maps',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Maps.vue')
                },
                {
                    path: '/tables',
                    name: 'tables',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Tables.vue')
                },
                {
                    path: '/time_keep_settings',
                    name: 'time_keep_settings',
                    component: () =>
                        import ('./views/Time Keep/Setting.vue')
                },
                {
                    path: '/time_keep_reports',
                    name: 'time_keep_reports',
                    component: () =>
                        import ('./views/Time Keep/Report.vue')
                },
            ]
        },
        {
            path: '/',
            redirect: 'loading_screen',
            component: AuthLayout,
            children: [{
                    path: '/os:storeId',
                    name: 'ecom_loading_screen',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/LoadingScreen.vue')
                },
                {
                    path: '/',
                    name: 'loading_screen',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/LoadingScreen.vue')
                },
                {
                    path: '/login',
                    name: 'login',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Login.vue')
                },
                {
                    path: '/time_entry',
                    name: 'time_entry',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/TimeEntry.vue')
                },
                {
                    path: '/password_reset',
                    name: 'password_reset',
                    component: () =>
                        import ('./views/PasswordReset.vue')
                },
                {
                    path: '/password_change',
                    name: 'password_change',
                    component: () =>
                        import ('./views/PasswordChange.vue')
                },
                {
                    path: '/register',
                    name: 'register',
                    component: () =>
                        import ( /* webpackChunkName: "demo" */ './views/Register.vue')
                }
            ]
        },
        {
            path: '/developer',
            redirect: 'developer_login',
            component: AuthLayout,
            children: [{
                path: '/developer',
                name: 'developer_login',
                component: () =>
                    import ('./views/DeveloperLogin.vue')
            }, ]
        },
        {
            path: '/connections',
            redirect: 'connections',
            component: AuthLayout,
            children: [{
                path: '/connections',
                name: 'connections',
                component: () =>
                    import ('./views/Connections.vue')
            }, ]
        },
        {
            path: '/developer_dashboard_main',
            name: 'developer_dashboard_main',
            component: DashboardLayout,
            children: [{
                    path: '/developer_dashboard',
                    name: 'developer_dashboard',
                    component: () =>
                        import ('./views/Dashboard.vue')
                },
                {
                    path: '/wavelets',
                    name: 'wavelets',
                    component: () =>
                        import ('./views/Wavelet/Wavelet.vue')
                },
                {
                    path: '/apps',
                    name: 'apps',
                    component: () =>
                        import ('./views/Wavelet/App.vue')
                },
                {
                    path: '/devices',
                    name: 'devices',
                    component: () =>
                        import ('./views/Wavelet/Device.vue')
                },
            ]
        },
        {
            path: '/:storeId/home',
            redirect: 'store',
            component: OnlineStoreLayout,
            children: [{
                    path: '/:storeId/home',
                    name: 'store',
                    component: () =>
                        import ('./views/Online Store/Home.vue')
                },
                {
                    path: '/:storeId/Catalog',
                    name: 'catalog',
                    component: () =>
                        import ('./views/Online Store/Catalog.vue')
                },
                {
                    path: '/:storeId/Customer_Login',
                    name: 'customer_login',
                    component: () =>
                        import ('./views/Online Store/CustomerLogin.vue')
                },
                {
                    path: '/:storeId/Customer_Register',
                    name: 'customer_register',
                    component: () =>
                        import ('./views/Online Store/CustomerRegister.vue')
                },
                {
                    path: '/:storeId/products/:id',
                    name: 'product',
                    component: () =>
                        import ('./views/Online Store/ProductForm.vue')
                },
                {
                    path: '/:storeId/cart',
                    name: 'cart',
                    component: () =>
                        import ('./views/Online Store/Cart.vue')
                },
                {
                    path: '/:storeId/checkout',
                    name: 'checkout',
                    component: () =>
                        import ('./views/Online Store/Checkout.vue')
                },
                {
                    path: '/:storeId/Collection/:collectionId',
                    name: 'collection',
                    component: () =>
                        import ('./views/Online Store/Catalog.vue')
                },
                {
                    path: '/:storeId/Account',
                    name: 'account',
                    component: () =>
                        import ('./views/Online Store/CustomerAccount.vue')
                },
                {
                    path: '/:storeId/Orders',
                    name: 'orders',
                    component: () =>
                        import ('./views/Online Store/MyOrder.vue')
                },
                {
                    path: '/:storeId/Addresses',
                    name: 'address',
                    component: () =>
                        import ('./views/Online Store/Addresses.vue')
                },
            ]
        },
        {
            path: '/',
            redirect: 'loading_screen',
            component: LandingPageLayout,
            children: [
            {
                path: '/signup_now',
                name: 'signup_now',
                component: () =>
                    import ('./views/LandingPage/Signup.vue')
            },
        ]
        },
        {
            path: '/*',
            name: 'server_response',
            component: ServerResponseLayout,
            children: [{
                    path: '/server_maintenance',
                    name: 'server_maintenance',
                    component: () =>
                        import ('./views/Server Response/503.vue')
                },
                // {
                //   path: '/*',
                //   name: 'page_not_found',
                //   component: () => import('./views/Server Response/404.vue')
                // },
            ]
        }

    ]
})

router.beforeEach((to, from, next) => {
    var logIn = secureStorage.getItem("loggedIn")
    var exempted_routes = [
        'loading_screen', 'login',
        'password_reset', 'password_change',
        'developer_login', 'developer_dashboard',
        'wavelets', 'store_login', ' store',
        'catalog', 'product', 'cart',
        'checkout', 'collection',
        'customer_login', 'customer_register',
        'ecom_loading_screen', 'server_maintenance',
        'online_stores', 'signup_now', 'connections','time_entry'
    ]

    let serverRunning = secureStorage.getItem("serverRunning")
    let down_exempted_routes = [
        'server_maintenance', 'loading_screen', 'ecom_loading_screen',
        'login', 'developer_login', 'store_login', 'customer_login', 'connections','time_entry'
    ]

    if (!serverRunning &&
        ![null, undefined].includes(serverRunning) &&
        !down_exempted_routes.includes(to["name"])) {
        router.push({ name: "server_maintenance" })
    } else if (logIn == false && !exempted_routes.includes(to["name"])) {
        alert("Cannot access BXI. You do not have active session for this device. Please login.")
            // Vue.prototype.$notification['alert']({
            //   message: 'Cannot access BXI',
            //   description: "You do not have active session for this device. Please login."
            // });
        router.push("/")
    } else {
        next()
    }
});

export default router;
